/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { debounce } from 'lodash';
import { FACETS_FIELD_KEY } from '@tcp/core/src/services/abstractors/productListing/productListing.utils';
import FilterCheckBox from '@tcp/core/src/components/common/atoms/FilterCheckBox/views/FilterCheckBox';
import React, { useEffect, useMemo, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import FilterColor from '@tcp/core/src/components/common/atoms/FilterColor/views/FilterColor';
import FilterPills from '@tcp/core/src/components/common/atoms/FilterPills/views/FilterPills';
import {
  scrollToBreadCrumb,
  setSessionStorage,
  getSessionStorage,
  removeSessionStorage,
} from '@tcp/core/src/utils/utils.web';
import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import style from '../styles/ProductFilter.style';
import FilterAccordion from '../../../../../../common/molecules/FilterAccordion/views/FilterAccordion';
import {
  DESCRIPTION_FILTER,
  FILTER_COLOR_SWATCH_URL,
} from '../../../container/ProductListing.constants';
import PriceRangeSlider from '../../../../../../common/atoms/PriceRangeSlider';
import submitProductListingFiltersForm from '../../../container/productListingOnSubmitHandler';
import FilterChips from '../../../../../../common/atoms/FilterChips/views/FilterChips';
import BopisFilter from '../../BopisFilter/views/BopisFilter';
import { setFilterOptions, checkMaxMinPriceRange, facetNameChange } from '../productFilterHelper';
import createPayload from '../../utils/filterAnalytics';
import { isShopThisStoreModeOn } from '../../../../../../../reduxStore/selectors/session.selectors';
import { getStoreFilterData } from '../../../../ShopThisStore/container/ShopThisStore.utils';
import { ProductFilterAccessibilityLabels } from './ProductFilter.labels';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import {
  getCurrentFeatureBrandAttribute,
  getFeatureBrand,
} from '../../../../SearchDetail/container/SearchDetail.util';
import { getAppliedPriceFilter } from '../../../../QuickFilters/utils';

/**
 * @function getFilterOptionsMap This handles to render the desktop filter fields of non-color
 * @summary  This is to set the non-color filters
 * @param {Array} colorOptionsMap - list of non-color options
 * @param {String} filterName - filter names "categoryPath2_uFilter, age_group_uFilter etc"
 */
function getFilterOptionsMap(optionsMap, facetName) {
  return optionsMap?.map((option) => ({
    value: option.id,
    title: option.displayName,
    disabled: option.disabled,
    name: facetName,
    ...(option.cleanSizeFacetForUrl && { cleanSizeFacetForUrl: option.cleanSizeFacetForUrl }),
  }));
}

const SIZE_RANGE = 'Size Range';

/**
 * @function getColorFilterOptionsMap This handles to render the desktop filter fields of color
 * @summary  This is to set the color filters
 * @param {Array} colorOptionsMap - list of color options
 */
function getColorFilterOptionsMap(colorOptionsMap, facetName) {
  return colorOptionsMap?.map((color) => {
    const imgUrl = `${FILTER_COLOR_SWATCH_URL}${color.id}.gif`;
    const imgData = { alt: color.displayName, url: imgUrl };
    const imgConfig = `w_50,h_50,c_thumb,g_auto:0`;
    const imgDataConfig = [`${imgConfig}`, `${imgConfig}`, `${imgConfig}`];
    const whiteColorClass = color.displayName?.toLowerCase() === 'white';
    return {
      value: color.id,
      title: color.displayName,
      imageData: imgData,
      imageConfig: imgDataConfig,
      colorName: color.displayName.toLowerCase(),
      name: facetName,
      class: `${whiteColorClass ? 'white-color' : ''}`,
    };
  });
}
const initialFilterValue = {
  TCPColor_uFilter: [],
  v_clothingsize_uFilter: [],
  page: [],
  sort: '',
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const ProductFilter = (props) => {
  const {
    filtersMaps,
    handleSubmit,
    filtersLength,
    isFavoriteView,
    initialValues,
    colorSeqMap,
    onSubmit,
    onFilterSelection,
    isLoadingMore,
    totalProductsCount,
    isABTestForStickyFilter,
    isBopisFilterOn,
    formValues,
    updateFormValue,
    getProducts,
    className,
    categoryPlp,
    newPriceRange,
    initialTrackWidth,
    selectedFilterOption,
    appliedFilters,
    hideAccordion,
    scrollSidebarToVisibleView,
    setBopisFilterStateActn,
    defaultStoreData,
    resetSuggestedStores,
    isBopisFilterEnabled,
    setTabPriceRange,
    tabPriceRange,
    trackClickAnalyticsBopisFilter,
    newFilterTrackAnalytics,
    isSizeGroupFilterEnabled,
    isCustomerRatingFilterWebEnabled,
    isTileRedesignAB,
    isHPLP,
    isFeatureBrandView,
    isFeatureBrandEnabled,
    setPriceFilterFlagActn,
    priceFilterFLag,
    isSoldOutView,
  } = props;
  const productFilterAccessibilityLabels = getLabelFromCopyOrFromTranslation(
    'global.accessibility',
    ProductFilterAccessibilityLabels
  );
  const [values, setFormvalues] = useState(formValues);
  const [minSelectedVal, setMinVal] = useState(newPriceRange?.min);
  const [maxSelectedVal, setMaxVal] = useState(newPriceRange?.max);
  const [priceFlag, setPriceFlag] = useState(false);
  const [minInitial, setMinInitial] = useState(null);
  const [maxInitial, setMaxInitial] = useState(null);
  const [initialRange, setInitialRange] = useState(false);
  const [checkAppliedRange, setCheckAppliedRange] = useState(false);
  const [priceRange, setPriceRange] = useState(null);
  const [childRef, setChildRef] = useState({});
  const [selectedFilterName, setSelectedFilterName] = useState({});
  const [filterToggleStates, setFilterToggleStates] = useState({ Category: categoryPlp });
  const isDesktop = isClient() && getViewportInfo()?.isDesktop;
  const filterRef = [];
  const priceMinInitial = 'pMinInitial';
  const priceMaxInitial = 'pMaxInitial';
  useEffect(() => {
    if (priceRange) {
      pushEventToAdobeAnalytics('apply_filter', createPayload(formValues));
      newFilterTrackAnalytics({ new_filter_cd50: createPayload(formValues) });
      let formDetails = formValues;
      if (isShopThisStoreModeOn()) {
        formDetails = {
          ...formValues,
          bopisStoreId: [getStoreFilterData()],
          sort: 'newest_score desc',
        };
      }
      submitProductListingFiltersForm(formDetails, false, getProducts);
      scrollToBreadCrumb();
    }
  }, [priceRange]);

  const getAppliedFiltersCount = () => {
    let count = 0;
    // returns count for the applied filters.
    // eslint-disable-next-line
    for (let key in initialValues) {
      count +=
        key.toLowerCase() !== FACETS_FIELD_KEY.sort &&
        key !== 'bopisStoreId' &&
        key !== getCurrentFeatureBrandAttribute(filtersMaps)
          ? initialValues[key].length
          : 0;
    }
    return count;
  };

  useEffect(() => {
    const pMinInitial = getSessionStorage(priceMinInitial);
    const pMaxInitial = getSessionStorage(priceMaxInitial);
    if (getAppliedFiltersCount() === 0) {
      setSessionStorage({ key: priceMinInitial, value: newPriceRange?.min });
      setSessionStorage({ key: priceMaxInitial, value: newPriceRange?.max });
      setMinInitial(newPriceRange?.min);
      setMaxInitial(newPriceRange?.max);
      setCheckAppliedRange(false);
    }
    if ((!minInitial && !maxInitial) || !initialRange) {
      if (
        (!pMinInitial && !pMaxInitial) ||
        (pMinInitial === 'undefined' && pMaxInitial === 'undefined') ||
        (pMinInitial === 'null' && pMaxInitial === 'null')
      ) {
        setSessionStorage({ key: priceMinInitial, value: newPriceRange?.min });
        setSessionStorage({ key: priceMaxInitial, value: newPriceRange?.max });
        setMinInitial(newPriceRange?.min);
        setMaxInitial(newPriceRange?.max);
        setCheckAppliedRange(false);
      } else {
        setMinInitial(parseFloat(pMinInitial));
        setMaxInitial(parseFloat(pMaxInitial));
        setCheckAppliedRange(true);
      }
    }
    if (!initialRange) {
      setInitialRange(true);
    }
  }, [newPriceRange, priceFlag, priceFilterFLag, tabPriceRange]);

  const { min: minPrice, max: maxPrice } = useMemo(
    () => getAppliedPriceFilter(appliedFilters) || {},
    [appliedFilters]
  );

  const filterKeys = Object?.keys(filtersMaps);
  const onAccordianClick = (filterName) => {
    setFilterToggleStates({ ...filterToggleStates, [filterName]: !filterToggleStates[filterName] });
  };
  let navBar;
  const handleNavBarEventListener = () => {
    setTimeout(() => {
      setFilterToggleStates({ Category: categoryPlp });
      setInitialRange(false);
      setCheckAppliedRange(false);
      removeSessionStorage(priceMinInitial);
      removeSessionStorage(priceMaxInitial);
    }, 0);
  };
  useEffect(() => {
    let navItem;
    if (isClient()) {
      navBar = isClient() && window?.document?.querySelectorAll('.nav-bar-l1');
      navItem = navBar?.[0];
      if (navItem) {
        navItem.addEventListener('click', handleNavBarEventListener);
      }
    }
    return () => {
      if (navItem) {
        navItem.removeEventListener('click', handleNavBarEventListener);
      }
    };
  }, []);

  useEffect(() => {
    setFilterToggleStates({ ...filterToggleStates, Category: categoryPlp });
  }, [categoryPlp]);

  useEffect(() => {
    setFilterToggleStates({
      ...filterToggleStates,
      [selectedFilterOption]: !filterToggleStates[selectedFilterOption],
    });
  }, []);

  const priceRangeNumFormatter = (num) =>
    typeof num === 'number' ? num?.toFixed(2) : parseFloat(num)?.toFixed(2);

  const updatePriceRange = (min, max) => {
    if (min !== null && max !== null) {
      const newMin = priceRangeNumFormatter(min);
      const newMax = priceRangeNumFormatter(max);
      setMinVal(newMin);
      setMaxVal(newMax);
    } else {
      setMinVal(min);
      setMaxVal(max);
    }
  };

  const handleImmediateSubmit = (formValues1) => {
    pushEventToAdobeAnalytics('apply_filter', createPayload(formValues1));
    const { submitting } = props;
    if (submitting) return;
    filterRef.forEach((filter) => {
      if (filter.filterRefType !== DESCRIPTION_FILTER) filter.closeMenu();
    });
    scrollSidebarToVisibleView(childRef?.[selectedFilterName] || 0); // scroll to current filter

    if (formValues1?.sort?.length) {
      newFilterTrackAnalytics({ new_filter_sort_cd51: createPayload(formValues1) });
      newFilterTrackAnalytics({ new_filter_sort_cd174: createPayload(formValues1) });
    }
    newFilterTrackAnalytics({ new_filter_cd50: createPayload(formValues1) });
    newFilterTrackAnalytics({ new_filter_cd161: createPayload(formValues1) });

    if (formValues1?.bopisStoreId?.length > 0) {
      if (formValues?.sort?.length > 0) {
        trackClickAnalyticsBopisFilter({
          bopis_cd50: createPayload(formValues1),
          customEvents: ['eventb50'],
        });
      }
      if (formValues?.sort?.length === 0) {
        trackClickAnalyticsBopisFilter({
          bopis_cd51: createPayload(formValues1),
          customEvents: ['eventb51'],
        });
      }
    }
    let formDetails = formValues1;
    if (isShopThisStoreModeOn()) {
      formDetails = {
        ...formValues1,
        bopisStoreId: [getStoreFilterData()],
        sort: 'newest_score desc',
      };
    }
    // eslint-disable-next-line consistent-return
    return onSubmit(formDetails, false, getProducts);
  };

  const priceFilterParams = debounce((selectedValues) => {
    updateFormValue('min_offer_price', [
      `${selectedValues?.minSelectedVal} TO ${selectedValues?.maxSelectedVal}`,
    ]);
    setPriceRange(selectedValues);
  }, 500);

  const handleSubmitForm = (field, newValue) => {
    handleSubmit((formValues1) => {
      let newFormValues = { ...formValues1 };
      if (newValue) {
        newFormValues[field] = newValue;
      } else if (field === 'clear' && !isFeatureBrandView) {
        newFormValues = { ...initialFilterValue };
      } else if (field === 'clear' && isFeatureBrandView) {
        // To persist the feature brand form values even when user clicks on clear all button.
        newFormValues = {
          ...initialFilterValue,
          [getCurrentFeatureBrandAttribute(filterKeys)]: [getFeatureBrand()],
        };
      }
      handleImmediateSubmit(newFormValues);
      scrollToBreadCrumb();
    })();
  };

  const renderColorFilterField = (appliedFilterVal, selectedFilters, filterName, facetName) => {
    return (
      <FilterAccordion
        filterName={filterName}
        selectedFilterOption={selectedFilterOption}
        onAccordianClick={onAccordianClick}
        visibility={filterToggleStates[filterName]}
        onClickAccordionScroll={scrollSidebarToVisibleView}
        setChildRefData={setChildRef}
        childRef={childRef}
        setSelectedFilterName={setSelectedFilterName}
      >
        <Field
          type="checkbox"
          name={facetName}
          component={FilterColor}
          optionsMap={getColorFilterOptionsMap(filtersMaps[facetName], facetName)}
          placeholder={filterName}
          allowMultipleSelections={!isFavoriteView}
          isFavoriteView={isFavoriteView}
          change={change}
          isLoadingMore={isLoadingMore}
          updateFormValue={updateFormValue}
          formValues={formValues}
          values={values}
          setSelectedFilterName={setSelectedFilterName}
          handleSubmitForm={handleSubmitForm}
        />
      </FilterAccordion>
    );
  };
  const renderSizeFitFilterField = (
    appliedFilterVal,
    selectedFilters,
    filterName,
    facetName,
    fitKey
  ) => {
    // const unbxdKeyMapping = filtersMaps.unbxdDisplayName;
    // const appliedFilterAvailable = getAppliedFiltersCount();

    const facetNameFit = fitKey;
    return (
      <FilterAccordion
        filterName={filterName}
        selectedFilterOption={selectedFilterOption}
        filtersLength={filtersLength}
        hideAccordion={hideAccordion}
        onAccordianClick={onAccordianClick}
        visibility={filterToggleStates[filterName]}
        onClickAccordionScroll={scrollSidebarToVisibleView}
        setChildRefData={setChildRef}
        childRef={childRef}
        setSelectedFilterName={setSelectedFilterName}
      >
        <Field
          id="fit"
          name={facetNameFit}
          component={FilterPills}
          type="checkbox"
          optionsMap={getFilterOptionsMap(filtersMaps[facetNameFit], facetName)}
          allowMultipleSelections={!isFavoriteView}
          isFavoriteView={isFavoriteView}
          isLoadingMore={isLoadingMore}
          values={values}
          formValues={formValues}
          setSelectedFilterName={setSelectedFilterName}
          placeholder="Size"
          handleSubmitForm={handleSubmitForm}
        />
        <Field
          type="checkbox"
          name={facetName}
          component={FilterCheckBox}
          optionsMap={getFilterOptionsMap(filtersMaps[facetName], facetName)}
          placeholder={filterName}
          allowMultipleSelections={!isFavoriteView}
          isFavoriteView={isFavoriteView}
          onFilterSelection={onFilterSelection}
          change={change}
          isLoadingMore={isLoadingMore}
          updateFormValue={updateFormValue}
          formValues={formValues}
          values={values}
          setSelectedFilterName={setSelectedFilterName}
          newFilterTrackAnalytics={newFilterTrackAnalytics}
          filterName={filterName}
          handleSubmitForm={handleSubmitForm}
        />
      </FilterAccordion>
    );
  };

  const renderPriceFilterField = (
    appliedFilterVal,
    selectedFilters,
    filterName,
    appliedPriceRange
  ) => {
    return (
      <FilterAccordion
        filterName={filterName}
        selectedFilterOption={selectedFilterOption}
        onAccordianClick={onAccordianClick}
        visibility={filterToggleStates[filterName]}
        onClickAccordionScroll={scrollSidebarToVisibleView}
        setChildRefData={setChildRef}
        childRef={childRef}
        setSelectedFilterName={setSelectedFilterName}
      >
        <PriceRangeSlider
          min={minInitial}
          max={maxInitial}
          minRange={0.01}
          initialTrackWidth={initialTrackWidth}
          // eslint-disable-next-line no-shadow
          onChange={({ min, max }) => updatePriceRange(min, max)}
          onDragEnd={() => {
            setSelectedFilterName(filterName);
            priceFilterParams({ minSelectedVal, maxSelectedVal });
          }}
          appliedPriceRange={appliedPriceRange}
          priceFlag={priceFilterFLag || priceFlag || tabPriceRange}
          setPriceFlag={setPriceFlag}
          setPriceFilterFlagActn={setPriceFilterFlagActn}
          priceFilterFLag={priceFilterFLag}
          setTabPriceRange={setTabPriceRange}
          checkAppliedRange={checkAppliedRange}
          setCheckAppliedRange={setCheckAppliedRange}
          dynamicMin={minPrice}
          dynamicMax={maxPrice}
        />
      </FilterAccordion>
    );
  };

  const renderCustomerRatingFilter = (appliedFilterVal, selectedFilters, filterName, facetName) => {
    return (
      <FilterAccordion
        filterName={filterName}
        selectedFilterOption={selectedFilterOption}
        filtersLength={filtersLength}
        hideAccordion={hideAccordion}
        onAccordianClick={onAccordianClick}
        visibility={filterToggleStates[filterName]}
        onClickAccordionScroll={scrollSidebarToVisibleView}
        setChildRefData={setChildRef}
        childRef={childRef}
        setSelectedFilterName={setSelectedFilterName}
      >
        <Field
          id="fit"
          name={FACETS_FIELD_KEY.rating}
          component={FilterPills}
          type="checkbox"
          optionsMap={getFilterOptionsMap(filtersMaps[FACETS_FIELD_KEY.rating], facetName)}
          allowMultipleSelections={false}
          isFavoriteView={isFavoriteView}
          isLoadingMore={isLoadingMore}
          values={values}
          formValues={formValues}
          setSelectedFilterName={setSelectedFilterName}
          placeholder="Size"
          ratingsFilter
          ratingLabel={productFilterAccessibilityLabels.lbl_rating}
          outOfLabel={productFilterAccessibilityLabels.lbl_out_of}
          isTileRedesignAB={isTileRedesignAB}
          handleSubmitForm={handleSubmitForm}
        />
      </FilterAccordion>
    );
  };

  const renderFilterField = (appliedFilterVal, selectedFilters, filterName, facetName) => {
    if (facetName === 'categoryPath2_uFilter' && categoryPlp) {
      return null;
    }
    if (
      facetName === FACETS_FIELD_KEY.cleanClothingSize ||
      facetName === FACETS_FIELD_KEY.sizeFitUrl
    ) {
      return null;
    }
    const filterName1 = () => {
      let fname = '';
      if (filterName === 'Quantity' || filterName === SIZE_RANGE) {
        if (filterName === 'Quantity') {
          fname = 'Multipacks';
        }
        if (filterName === SIZE_RANGE) {
          fname = 'Age Group';
        }
      } else {
        return '';
      }
      return fname;
    };
    return (
      <FilterAccordion
        filterName={filterName1() ? filterName1() : filterName}
        selectedFilterOption={selectedFilterOption}
        filtersLength={filtersLength}
        onAccordianClick={onAccordianClick}
        visibility={filterToggleStates[filterName1() ? filterName1() : filterName]}
        onClickAccordionScroll={scrollSidebarToVisibleView}
        setChildRefData={setChildRef}
        childRef={childRef}
        setSelectedFilterName={setSelectedFilterName}
      >
        <Field
          type="checkbox"
          name={facetName}
          component={FilterCheckBox}
          optionsMap={getFilterOptionsMap(filtersMaps[facetName], facetName)}
          placeholder={filterName}
          allowMultipleSelections={!isFavoriteView}
          isFavoriteView={isFavoriteView}
          onFilterSelection={onFilterSelection}
          change={change}
          isLoadingMore={isLoadingMore}
          updateFormValue={updateFormValue}
          formValues={formValues}
          values={values}
          setSelectedFilterName={setSelectedFilterName}
          newFilterTrackAnalytics={newFilterTrackAnalytics}
          filterName={filterName1() ? filterName1() : filterName}
          handleSubmitForm={handleSubmitForm}
        />
      </FilterAccordion>
    );
  };

  const isSizeFitFilterAvailable = () => {
    let isSizeFilter = null;
    let isFitFilter = null;
    // eslint-disable-next-line array-callback-return
    filterKeys.map((key) => {
      if (key.toLowerCase() === FACETS_FIELD_KEY.fit) {
        isFitFilter = key;
      } else if (key.toLowerCase() === FACETS_FIELD_KEY.size) {
        isSizeFilter = key;
      }
    });
    return { isSizeFilter, isFitFilter };
  };

  const renderSizeAndFitFields = (
    appliedFilterVal,
    selectedFilters,
    filterName,
    facetName,
    isSize,
    isFit
    // eslint-disable-next-line consistent-return
  ) => {
    if (isSize) {
      return renderSizeFitFilterField(
        appliedFilterVal,
        selectedFilters,
        filterName,
        facetName,
        isFit
      );
    }
  };

  const renderRatingFilterFields = (appliedFilterVal, selectedFilters, filterName, facetName) => {
    return renderCustomerRatingFilter(appliedFilterVal, selectedFilters, filterName, facetName);
  };

  const unbxdKeyMapping = filtersMaps?.unbxdDisplayName;
  let filterOptions = [...filterKeys];
  const updatedFacetNames = facetNameChange(unbxdKeyMapping);

  if (isDesktop) {
    filterOptions = filterKeys;
  } else {
    filterOptions = setFilterOptions(selectedFilterOption, filterKeys, updatedFacetNames);
  }

  const getSizeFilterComponents = (key, appliedFilterAvailable, isSizeFilter, isFitFilter) => {
    return (
      filtersMaps[key].length > 0 &&
      renderSizeAndFitFields(
        appliedFilterAvailable && appliedFilters[key],
        !isFavoriteView ? filtersLength[`${key}Filters`] : 'Display',
        unbxdKeyMapping[key],
        key,
        isSizeFilter,
        isFitFilter
      )
    );
  };

  const getRatingFilterComponents = (key, appliedFilterAvailable) => {
    return (
      filtersMaps[key].length > 0 &&
      renderRatingFilterFields(
        appliedFilterAvailable && appliedFilters[key],
        !isFavoriteView ? filtersLength[`${key}Filters`] : 'Display',
        unbxdKeyMapping[key],
        key
      )
    );
  };

  const getColorFilterComponent = (key, appliedFilterAvailable) => {
    let appliedPriceRange = {};
    appliedFilters.forEach((val) =>
      val?.forEach((obj) => {
        if (obj?.facetName === 'min_offer_price') {
          appliedPriceRange = { ...obj };
        }
      })
    );

    return (
      checkMaxMinPriceRange(filtersMaps?.newPriceRange) &&
      renderPriceFilterField(
        appliedFilterAvailable && appliedFilters[key],
        filtersLength[`${key}Filters`],
        unbxdKeyMapping[key],
        appliedPriceRange
      )
    );
  };

  const renderFilterFormElements = () => {
    const appliedFilterAvailable = getAppliedFiltersCount();
    const { isSizeFilter, isFitFilter } = isSizeFitFilterAvailable();
    let filterList = {};
    // eslint-disable-next-line complexity
    return (
      filterOptions
        ?.filter((filterOption) => {
          if (!isFeatureBrandView) return true;
          return (
            filterOption?.toLowerCase() !==
            getCurrentFeatureBrandAttribute(filterKeys).toLowerCase()
          );
        })
        // eslint-disable-next-line complexity
        ?.map((key) => {
          if (
            key?.toLowerCase() !== FACETS_FIELD_KEY.unbxdDisplayName &&
            key?.toLowerCase() !== FACETS_FIELD_KEY.l1category &&
            filtersMaps[key]
          ) {
            if (key?.toLowerCase() === FACETS_FIELD_KEY.color) {
              filterList =
                filtersMaps[key].length > 0 &&
                renderColorFilterField(
                  appliedFilterAvailable && appliedFilters[key],
                  filtersLength[`${key}Filters`],
                  unbxdKeyMapping[key],
                  key
                );
            } else if (key?.toLowerCase() === FACETS_FIELD_KEY.size) {
              if (isSizeGroupFilterEnabled) return false;
              filterList = getSizeFilterComponents(
                key,
                appliedFilterAvailable,
                isSizeFilter,
                isFitFilter
              );
            } else if (key === FACETS_FIELD_KEY.rating) {
              if (isCustomerRatingFilterWebEnabled) {
                filterList = getRatingFilterComponents(key, appliedFilterAvailable);
              } else {
                return false;
              }
            } else if (key?.toLowerCase() === FACETS_FIELD_KEY.clothingsize) {
              if (!isSizeGroupFilterEnabled) return false;
              filterList = getSizeFilterComponents(
                key,
                appliedFilterAvailable,
                isSizeFilter,
                isFitFilter
              );
            } else if (
              (key?.toLowerCase() === FACETS_FIELD_KEY.shoessize ||
                key?.toLowerCase() === FACETS_FIELD_KEY.accessoriessize) &&
              !isSizeGroupFilterEnabled
            ) {
              return false;
            } else if (key?.toLowerCase() === FACETS_FIELD_KEY.fit) {
              filterList = null;
            } else if (key.toLowerCase() === FACETS_FIELD_KEY.price) {
              filterList = getColorFilterComponent(key, appliedFilterAvailable);
            } else {
              filterList =
                filtersMaps[key].length > 0 &&
                renderFilterField(
                  appliedFilterAvailable && appliedFilters[key],
                  !isFavoriteView ? filtersLength[`${key}Filters`] : 'Display',
                  unbxdKeyMapping[key],
                  key
                );
            }
            return filterList;
          }
          return false;
        })
    );
  };

  const checkAppliedFilters = () => {
    let check = false;
    appliedFilters
      ?.filter((filter) => {
        if (!isFeatureBrandView) return true;
        return filter[0]?.facetName !== getCurrentFeatureBrandAttribute(filterKeys);
      })
      .forEach((item) => {
        if (item.length > 0) {
          check = true;
        }
      });
    return check;
  };

  const checkBopisVisibility = () => {
    if (isDesktop) {
      return true;
    }
    const filterOptionCheck = filterOptions.length > 1;
    if (filterOptionCheck) {
      return true;
    }
    return false;
  };
  return (
    <div className={`${className} product-filter`}>
      {isBopisFilterEnabled && checkBopisVisibility() && !isHPLP && (
        <div className="bopis-filter-redesign">
          <BopisFilter
            isBopisFilterOn={isBopisFilterOn}
            formValues={formValues}
            getProducts={getProducts}
            onSubmit={onSubmit}
            updateFormValue={updateFormValue}
            setBopisFilterStateActn={setBopisFilterStateActn}
            defaultStoreData={defaultStoreData}
            resetSuggestedStores={resetSuggestedStores}
            trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
            isFeatureBrandView={isFeatureBrandView}
            isFeatureBrandEnabled={isFeatureBrandEnabled}
          />
        </div>
      )}
      {!isSoldOutView && (
        <form
          className="product-filter-from"
          onSubmit={handleSubmit((formValues1) => {
            handleImmediateSubmit(formValues1);
            scrollToBreadCrumb();
          })}
        >
          {checkAppliedFilters() ? (
            <FilterChips
              auxColorMap={colorSeqMap}
              appliedFilters={appliedFilters}
              initialValues={initialValues}
              change={change}
              isLoadingMore={isLoadingMore}
              totalProductsCount={totalProductsCount}
              isABTestForStickyFilter={isABTestForStickyFilter}
              isBopisFilterOn={isBopisFilterOn}
              getProducts={getProducts}
              formValues={formValues}
              values={values}
              updateFormValue={updateFormValue}
              setFormvalues={setFormvalues}
              setPriceFlag={setPriceFlag}
              setPriceFilterFlagActn={setPriceFilterFlagActn}
              priceFilterFLag={priceFilterFLag}
              categoryPlp={categoryPlp}
              handleSubmitForm={handleSubmitForm}
              isFeatureBrandView={isFeatureBrandView}
              filterKeys={filterKeys}
            />
          ) : (
            ''
          )}
          {renderFilterFormElements()}
        </form>
      )}
    </div>
  );
};

ProductFilter.propTypes = {
  className: PropTypes.string,
  filtersMaps: PropTypes.shape({}),
  totalProductsCount: PropTypes.string,
  initialValues: PropTypes.shape({}),
  filtersLength: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number])),
  onSubmit: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  // sortLabels: PropTypes.arrayOf(PropTypes.shape({})),
  favoriteSortingParams: PropTypes.shape({}),
  formValues: PropTypes.shape({ sort: PropTypes.string }),
  isLoadingMore: PropTypes.bool,
  isBopisFilterOn: PropTypes.bool,
  isABTestForStickyFilter: PropTypes.bool,
  updateFormValue: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  isFavoriteView: PropTypes.bool,
  colorSeqMap: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string])),
  onFilterSelection: PropTypes.func,
  categoryPlp: PropTypes.bool,
  categoryNavData: PropTypes.shape({}),
  handleSubmit: PropTypes.func.isRequired,
  newPriceRange: PropTypes.shape({}),
  initialTrackWidth: PropTypes.number,
  selectedFilterOption: PropTypes.string,
  appliedFilters: PropTypes.shape([]),
  setTabPriceRange: PropTypes.func,
  tabPriceRange: PropTypes.bool,
  trackClickAnalyticsBopisFilter: PropTypes.func,
  isSizeGroupFilterEnabled: PropTypes.bool,
  isCustomerRatingFilterWebEnabled: PropTypes.bool,
};
ProductFilter.defaultProps = {
  filtersMaps: {},
  className: '',
  totalProductsCount: '0',
  initialValues: {},
  filtersLength: {},
  // sortLabels: [],
  favoriteSortingParams: null,
  formValues: { sort: '' },
  isLoadingMore: false,
  isBopisFilterOn: false,
  isABTestForStickyFilter: false,
  submitting: false,
  isFavoriteView: false,
  colorSeqMap: {},
  onFilterSelection: () => {},
  categoryPlp: false,
  categoryNavData: {},
  newPriceRange: {},
  initialTrackWidth: 100,
  selectedFilterOption: '',
  appliedFilters: [],
  setTabPriceRange: () => {},
  tabPriceRange: false,
  trackClickAnalyticsBopisFilter: () => {},
  isSizeGroupFilterEnabled: false,
  isCustomerRatingFilterWebEnabled: false,
};

export default reduxForm({
  form: 'filter-form', // a unique identifier for this form
  enableReinitialize: true,
})(withStyles(ProductFilter, style));
export { ProductFilter as ProductFilterVanilla };
